import { MOBILE } from '../../../constants/breakpoints';

export const selectorStyle = theme => ({
    container: {
        width: '100%',

        '& div + div:last-child': {
            paddingBottom: '1rem'
        },

        '& .MuiTypography-caption, .MuiTypography-body2': {
            padding: 0,
            color: '#000000DE',
            margin: 0
        },

        [theme.breakpoints.up(MOBILE)]: {
            border: '1px solid #ccc',
            width: '100%',
            borderRadius: 10
        }
    }
});

export const selectorRowStyle = theme => ({
    root: {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '.5rem 1rem',
        '& span': {
            fontSize: 14
        },

        [theme.breakpoints.up(MOBILE)]: {
            border: '3px solid transparent',

            '&:hover': {
                border: '3px solid #2b78e4',
                color: '#2b78e4'
            }
        }
    }
});
